import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { ExplanationAccordion } from 'components'
import { PersonHREmploymentInformationDto, personHREmploymentInformationValidationSchema } from 'dtos'
import { Formik } from 'formik'
import moment from 'moment'

interface AddressesAddEditDialogProps {
  initialValues: PersonHREmploymentInformationDto
  loading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function AddressesAddEditDialog({ initialValues, loading, onClose, onSave, open }: AddressesAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={personHREmploymentInformationValidationSchema}
      >
        {({ errors, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Edit HR/Employment Information</DialogTitle>

                  <Grid item xs={12}>
                    <DatePicker
                      disabled={loading || isSubmitting}
                      label='Start Date'
                      onChange={newValue => {
                        if (newValue) {
                          setFieldValue('employmentStartDate', newValue.format('yyyy-MM-DD'))
                        } else {
                          setFieldValue('employmentStartDate', undefined)
                        }
                      }}
                      slotProps={{
                        actionBar: {
                          actions: ['clear']
                        },
                        textField: {
                          error: Boolean(touched.employmentStartDate && errors.employmentStartDate),
                          helperText: touched.employmentStartDate && errors.employmentStartDate
                        }
                      }}
                      value={values.employmentStartDate ? moment(values.employmentStartDate) : null}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <DatePicker
                      disabled={loading || isSubmitting}
                      label='End Date'
                      onChange={newValue => {
                        if (newValue) {
                          setFieldValue('employmentEndDate', newValue.format('yyyy-MM-DD'))
                        } else {
                          setFieldValue('employmentEndDate', undefined)
                        }
                      }}
                      slotProps={{
                        actionBar: {
                          actions: ['clear']
                        },
                        textField: {
                          error: Boolean(touched.employmentEndDate && errors.employmentEndDate),
                          helperText: touched.employmentEndDate && errors.employmentEndDate
                        }
                      }}
                      value={values.employmentEndDate ? moment(values.employmentEndDate) : null}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <DatePicker
                      disabled={loading || isSubmitting}
                      label='Birthday'
                      onChange={newValue => {
                        if (newValue) {
                          setFieldValue('birthday', newValue.format('yyyy-MM-DD'))
                        } else {
                          setFieldValue('birthday', undefined)
                        }
                      }}
                      slotProps={{
                        actionBar: {
                          actions: ['clear']
                        },
                        textField: {
                          error: Boolean(touched.birthday && errors.birthday),
                          helperText: touched.birthday && errors.birthday
                        }
                      }}
                      value={values.birthday ? moment(values.birthday) : null}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion>||All fields are optional. ||</ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} color='inherit' onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
